import styles from './index.module.scss';
import { utility } from '@phi/components';
import { h } from 'vue';

const pointer_event_click = (el: HTMLElement) => {
    const rect = el.getBoundingClientRect();
    const evt = new PointerEvent('pointerup', {
        clientX: rect.left + rect.width/2,
        clientY: rect.top + rect.height/2,
        pointerId: 1,
        pointerType: 'mouse',
    });
    el.dispatchEvent(evt);
    el.parentElement?.dispatchEvent(evt);
};

function src(btn: HTMLButtonElement) {
    const img = btn.querySelector('img');
    return img instanceof HTMLImageElement && img.src
        ? img.src
        : '';
}

function on_button_click(id: string, e: MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    const btn = document.querySelector('#' + id);
    if (btn instanceof HTMLButtonElement)
        pointer_event_click(btn);
}

export function ModalButton(id: string, label: string, shortcut: string | undefined) {
    const element = document.querySelector('#' + id);
    if (!(element instanceof HTMLButtonElement))
        return '';
    return h('div', {
        class: {
            [styles.wrapper]: true,
            'btn-wrapper': true,
            hidden: element.classList.contains('disabled'),
        },
    }, [
        h('button', {
            type: 'button',
            id: id + '-float',
            class: {
                [styles.button]: true,
                btn: true,
                uibtn: true,
                active: element.classList.contains('active'),
            },
            onClick: (e: MouseEvent) => on_button_click(id, e),
        }, h('img', { class: 'iconimg', src: src(element) })),

        ModalLabel(label, shortcut),
    ]);
}

export function ModalLabel(label: string, shortcut: string | undefined) {
    return h('div', { class: styles.label }, [
        h('span', label),
        shortcut
            ? [' (', h('strong', { class: utility.color_brand }, shortcut), ')']
            : '',
    ]);
}
